<template>
  <div class="container">
    <!--  头部条-->
    <div class="topContainer">
      <div class="topContainer_inner">
        <div
            v-tracking="{module:'xsd_word',actionName: $trackConfig['xsd_word_goHome'],actionCode:'xsd_word_goHome'}" class="goIndexBtn"
            @click="goHome">
          回到标书对比首页
        </div>
        <div style="flex: 1;"></div>
        <div v-tracking="{module:'xsd_word',actionName: $trackConfig['xsd_word_export'],actionCode:'xsd_word_export'}" class="exportBtn"
             @click="export_result">
          导出
        </div>
      </div>
    </div>
    <div class="mainContainer">
      <div class="mainInner">
        <div class="muluContainer">
          <div :class="{activeTag:showSummery}" class="tagContainer" @click="showSummery = true">
            <span>结果总览</span>
          </div>
          <div v-for="(item,idx) in allTags" :key="idx"
               :class="{activeTag:(item.name == currentTagKey)&& !showSummery }"
               class="tagContainer"
               @click="changeTag(item)">
            <span>{{ item.name }}</span>
            <span v-if="true" style="margin-left: 10px;">
            <span v-if="( item.sim_num  == 0)" class="green" style="font-size: 12px">(正常)</span>
            <span v-else style="font-size: 12px">  <span class="red">({{ item.sim_num }})</span>个异常</span>
          </span>
            <span v-else style="position:absolute;right: 4px;">
            <i class="el-icon-loading" style="margin-right:10px;color: #224AE3;"></i>
          </span>
          </div>
        </div>
        <div class="contentContainer">
          <el-table
              v-if="!showSummery"
              :data="currentTagData.details"
              :header-cell-style="{
                color: '#000',
                height: '48px',
              }"
              height="250"
              style="border: 1px solid #eee"
          >
            <el-table-column
                :show-overflow-tooltip="true"
                align="left"
                header-align="left"
                label="基准文件"

            >
              <template slot-scope="scope">
                {{ scope.row.mulu }}
              </template>
            </el-table-column>
            <el-table-column
                :show-overflow-tooltip="true"
                align="left"
                header-align="left"
                label="目标文件"
            >
              <template slot-scope="scope">
                {{ scope.row.cont_name + "—" + scope.row.cont_mulu }}
              </template>
            </el-table-column>
            <el-table-column
                :show-overflow-tooltip="true"
                align="left"
                header-align="left"
                label="检查状态"
                width="100px"

            >
              <template slot-scope="scope">
              <span v-if="scope.row.finished">
                 <span class="green">检查完成</span>
              </span>
                <span v-else>
                <span style="color:#F59A23">检查中</span>
              </span>
              </template>
            </el-table-column>
            <el-table-column
                v-if="hasPara"
                align="left"
                header-align="left"
                label="文本相似异常"
                width="100px">
              <template slot-scope="scope">
              <span v-if="scope.row.finished">
                 <span v-if="scope.row.para_sim_count" class="red">{{ scope.row.para_sim_count }}</span>
                 <span v-else>0</span>
              </span>
                <span v-else>
                <span>--</span>
              </span>
              </template>
            </el-table-column>
            <el-table-column
                v-if="hasImg"
                align="left"
                header-align="left"
                label="图片相似异常"
                width="100px">
              <template slot-scope="scope">
              <span v-if="scope.row.finished">
                 <span v-if="scope.row.sim_img_count" class="red">{{ scope.row.sim_img_count }}</span>
                 <span v-else>0</span>
              </span>
                <span v-else>
                <span>--</span>
              </span>
              </template>
            </el-table-column>
            <el-table-column
                v-if="hasAuthor"
                align="left"
                header-align="left"
                label="作者雷同"
                width="100px">
              <template slot-scope="scope">
              <span v-if="scope.row.finished">
                 <span v-if="scope.row.author_sim_count" class="red">{{ scope.row.author_sim_count }}</span>
                 <span v-else>0</span>
              </span>
                <span v-else>
                <span>--</span>
              </span>
              </template>
            </el-table-column>
            <el-table-column
                v-if="hasPhone"
                align="left"
                header-align="left"
                label="电话号相似异常"
                width="120px">
              <template slot-scope="scope">
              <span v-if="scope.row.finished">
                 <span v-if="scope.row.phone_sim_count" class="red">{{ scope.row.phone_sim_count }}</span>
                 <span v-else>0</span>
              </span>
                <span v-else>
                <span>--</span>
              </span>
              </template>
            </el-table-column>
            <el-table-column
                align="left"
                header-align="left"
                label="相似度"
                width="100px">
              <template slot-scope="scope">
              <span v-if="scope.row.finished">
                 <span>{{ scope.row.similarity }}</span>
              </span>
                <span v-else>
                <span>--</span>
              </span>
              </template>
            </el-table-column>
            <el-table-column
                align="left"
                header-align="left"
                label="操作"
                width="100px">
              <template slot-scope="scope">
              <span v-if="scope.row.finished">
                 <span style="color: #3491F9;cursor: pointer" @click="showDetail(scope.row)">查看</span>
              </span>
                <span v-else>
                <span>--</span>
              </span>
              </template>
            </el-table-column>

          </el-table>
          <div v-else style="flex:1;display: flex;flex-direction: column;">
            <div class="title_withLine" style="margin-bottom: 20px;">标书对比报告</div>
            <el-descriptions :column="2" size="medium" style="padding:15px 20px;background: #eee;">
              <el-descriptions-item label="待查文档数量">{{ evaluationData.file_amount }}份</el-descriptions-item>
              <el-descriptions-item label="提取段落个数">{{ evaluationData.total_para_amount }}个</el-descriptions-item>
              <el-descriptions-item label="开始时间">{{ evaluationData.start_time }}</el-descriptions-item>
              <el-descriptions-item label="检查结果"><span v-if="true">检查成功且揪出异常内容</span><span
                  v-else>本次检查不扣费</span></el-descriptions-item>
              <el-descriptions-item label="提取表格个数">{{ evaluationData.total_table_amount }}个</el-descriptions-item>
              <el-descriptions-item label="提取总文字数">{{ evaluationData.total_words_amount }}字</el-descriptions-item>
              <el-descriptions-item label="文档交叉组合">{{ evaluationData.file_group_amount }}种</el-descriptions-item>
              <el-descriptions-item :span="2" label="预计段落组合">{{
                  evaluationData.para_group_amount
                }}个
              </el-descriptions-item>
            </el-descriptions>
            <div style="flex:1;margin-top: 20px;">
              <el-table
                  :data="allTags"
                  :header-cell-style="{
                    color: '#000',
                    height: '48px',
                  }"
                  height="250"
                  style="border: 1px solid #eee">
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="left"
                    header-align="left"
                    label="序号"
                    type="index">

                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="left"
                    header-align="left"
                    label="投标单位"
                    prop="name"
                >

                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="left"
                    header-align="left"
                    label="检查状态"
                >
                  <template slot-scope="scope">
                    <span style="color: green;">检查完成</span>
                  </template>
                </el-table-column>
                <el-table-column
                    v-if="hasPara"
                    :show-overflow-tooltip="true"
                    align="left"
                    header-align="left"
                    label="文本相似数量"
                >
                  <template slot-scope="scope">
                    <span style="color: red;">
                      {{ scope.row.para_sim_count }}
                    </span>
                  </template>
                </el-table-column>
                <el-table-column
                    v-if="hasImg"
                    :show-overflow-tooltip="true"
                    align="left"
                    header-align="left"
                    label="图片相似数量"
                >
                  <template slot-scope="scope">
                    <span style="color: red;">
                      {{ scope.row.sim_img_count }}
                    </span>
                  </template>
                </el-table-column>
                <el-table-column
                    v-if="hasAuthor"
                    :show-overflow-tooltip="true"
                    align="left"
                    header-align="left"
                    label="作者雷同"
                >
                  <template slot-scope="scope">
                    <span style="color: red;">
                      {{ scope.row.author_sim_count}}
                    </span>
                  </template>
                </el-table-column>
                <el-table-column
                    v-if="hasPhone"
                    :show-overflow-tooltip="true"
                    align="left"
                    header-align="left"
                    label="电话号相似数量"
                >
                  <template slot-scope="scope">
                    <span style="color: red;">
                      {{ scope.row.phone_sim_count}}
                    </span>
                  </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="left"
                    header-align="left"
                    label="操作"
                >
                  <template slot-scope="scope">
                    <span v-tracking="{module:'xsd_word',actionName: $trackConfig['xsd_word_detail'],actionCode:'xsd_word_detail'}" style="color: #3491F9;cursor: pointer"
                          @click="changeTag(scope.row)">
                     查看
                    </span>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <detail v-if="detailVisible" :abnormalResult="abnormalResult" :phoneAbnormalResult="phoneAbnormalResult" :imageData="imageData" :result="showResult"
            :simIdx="simIdx"
            :visible="detailVisible" @close_detail="detailVisible = false"></detail>
  </div>
</template>

<script>
import {getExportFile} from "@/api/common"
import {getResult, getAbnormal, getImgInfo, getFileList,getPhoneAbnormal} from "@/api/word";
import detail from "@/views/word/detail";
import {mapMutations, mapState} from "vuex";

export default {
  name: "result",
  components: {
    detail
  },
  data() {
    return {
      result: [],
      abnormalResult: {},//异常列表
      phoneAbnormalResult:{},
      simIdx: "",
      detailVisible: false,
      showSummery: true,
      // 当前选中的标签
      currentTagKey: "",
      // 当前选中标签下的数据 相似度数据
      currentTagData: {},
      imageData: {},
      // 上传时的参数信息
      info: {},
      deductionNumber:0,
      deduction: false
    }
  },
  async created() {
    await this.getFileList();
    await this.getResult();
    await this.getAbnormal();
    await this.getPhoneAbnormal();
    await this.getImageInfo();
  },
  mounted() {
    this.currentTagKey = this.allTags[0].name
    this.currentTagData = this.showResult[this.currentTagKey];
  },
  methods: {
    /**
     * 获取文件列表
     * @returns {Promise<void>}
     */
    async getFileList() {
      let res = await getFileList({
        project: this.projectId,
        sign_name: this.sign_name
      });
      this.info = res.data;
      let flag_setting = this.info.flag_setting ? this.info.flag_setting : {};
      if("para_sim_flag" in flag_setting || "table_sim_flag" in flag_setting){
        this.setHasPara(true)
      }else{
        this.setHasPara(false)
      }

      if ("author_sim_flag" in flag_setting) {
        this.setHasAuthor(true)
      } else {
        this.setHasAuthor(false)
      }
      if ("phone_sim_flag" in flag_setting) {
        this.setHasPhone(true)
      } else {
        this.setHasPhone(false)
      }
    },
    /**
     * 获取结果
     */
    async getResult() {
      let res = await getResult({
        project: this.projectId,
        sign_name: this.sign_name,
        vipServiceGuid: this.serviceInfo.vipServiceGuid
      });
      let data = res.data;
      this.deduction = data.deduction;
      this.deductionNumber = data.projectInfo?.deductionNumber?data.projectInfo?.deductionNumber:0;
      let temp = [];
      this.$_.each(data.resultHead?.sim_result, (item) => {
        temp = temp.concat(item.sims)
      })
      this.result = temp;
    },
    /**
     * 获取图片结果
     */
    async getImageInfo() {
      let flag_setting = this.info.flag_setting ? this.info.flag_setting : {};
      if ("img_sim_flag" in flag_setting) {
        this.setHasImg(true)
        let res = await getImgInfo({
          project: this.projectId,
          sign_name: this.sign_name
        });
        this.imageData = res.data;
      } else {
        this.setHasImg(false)
      }
    },

    /**
     * 异常列表信息
     */
    async getAbnormal() {
      let res = await getAbnormal({
        project: this.projectId,
        sign_name: this.sign_name
      })
      this.abnormalResult = res.data;
    },
    /**
     * 电话号异常
     */
    async getPhoneAbnormal(){
      let res = await getPhoneAbnormal({
        project: this.projectId,
        sign_name: this.sign_name
      })
      this.phoneAbnormalResult = res.data;
    },
    /**
     * 切换投标单位
     */
    changeTag(item) {
      this.showSummery = false;
      this.currentTagKey = item.name;
      this.currentTagData = this.showResult[this.currentTagKey];
    },
    /**
     * 查看详情
     */
    showDetail(item) {
      this.simIdx = item.idx;
      this.detailVisible = true;
    },
    async export_result() {
      let res = await getExportFile({
        project: this.projectId,
        sign_name: this.sign_name
      })
      let url = res.data;
      this.$util.downloadExportUrl(url, this.checkName);
    },
    goHome() {
      this.$router.push({
        name: "Home",
        params: {
          init: true
        }
      })
    },
    ...mapMutations('word', ['setHasImg', 'setHasPhone', 'setHasAuthor','setHasPara'])
  },
  computed: {
    ...mapState('word', ['projectId', "sign_name", "checkName", "baseData", "processData", "evaluationData", "hasImg", "hasAuthor", 'hasPhone','hasPara']),
    ...mapState('user', ['serviceInfo']),
    showResult() {
      let baseData = JSON.parse(JSON.stringify(this.baseData.info));
      this.$_.each(this.result, (item) => {
        let details = baseData[item.name].details;
        this.$_.each(details, (d) => {
          if (item.idx === d.idx) {
            for (let k in item) {
              d[k] = item[k]
            }
            d.finished = true;
          }
        })
      })
      this.$_.each(baseData, (item) => {
        let sim_num = 0;
        let para_sim_count = 0;
        let sim_img_count = 0;
        let phone_sim_count = 0;
        let author_sim_count = 0;
        this.$_.each(item.details, (d) => {
          d.finished = true; // 设定都完成
          if (d.finished) {
            if (d.author_sim_count) {
              d.author_sim_count = 1
            } else {
              d.author_sim_count = 0
            }
            sim_num += d.para_sim_count + d.sim_img_count + d.phone_sim_count + d.author_sim_count;
            para_sim_count += d.para_sim_count;
            sim_img_count += d.sim_img_count;
            phone_sim_count += d.phone_sim_count;
            author_sim_count += d.author_sim_count;
          }
        })
        item.para_sim_count = para_sim_count;
        item.sim_img_count = sim_img_count;
        item.phone_sim_count = phone_sim_count;
        item.author_sim_count = author_sim_count;
        item.sim_num = sim_num;
      })
      return baseData
    },
    allTags() {
      let showResult = this.showResult;
      let processData = this.processData;
      let sch_detail = processData.sch_detail;
      let tempArr = [];
      this.$_.each(sch_detail, (val, key) => {
        let obj = {
          name: key,
          status: val,
          para_sim_count: showResult[key] ? (showResult[key].para_sim_count ? showResult[key].para_sim_count : 0) : 0,
          sim_img_count: showResult[key] ? (showResult[key].sim_img_count ? showResult[key].sim_img_count : 0) : 0,
          phone_sim_count:showResult[key]?(showResult[key].phone_sim_count?showResult[key].phone_sim_count:0):0,
          author_sim_count:showResult[key]?(showResult[key].author_sim_count?showResult[key].author_sim_count:0):0,
          sim_num: showResult[key] ? (showResult[key].sim_num ? showResult[key].sim_num : 0) : 0
        }
        tempArr.push(obj)
      })
      return tempArr
    }
  },
  watch: {
    showResult(val) {
      this.currentTagData = val[this.currentTagKey];
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  flex: 1;
  height: 1px;
  display: flex;
  flex-direction: column;
}

.topContainer {
  background-image: url("~@/assets/image/topbg.png");
  background-repeat: no-repeat;
  height: 56px;

  &_inner {
    width: $innerWidth;
    height: 100%;
    margin: 0 auto;
    display: flex;
  }
}

.mainContainer {
  flex: 1;
  height: 1px;
  background-image: url("~@/assets/image/indexbg1.png"), url("~@/assets/image/indexbg.png");
  background-size: auto auto, 100% 100%;
  background-repeat: no-repeat;
  background-color: #fff;
  display: flex;
  flex-direction: column;

  .mainInner {
    flex: 1;
    height: 1px;
    width: $innerWidth;
    margin: 10px auto;
    box-sizing: border-box;
    display: flex;
    background: #fff;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
    border-radius: 4px;
  }
}

.muluContainer {
  width: 200px;
  font-size: 14px;
  font-weight: bold;
  height: 100%;
  overflow: auto;
  box-sizing: border-box;

  .tagContainer {
    height: 56px;
    line-height: 56px;
    cursor: pointer;
    border-bottom: 1px solid #ddd;
    padding-left: 10px;
    display: flex;
    color: #000;
    position: relative;
    font-size: 14px;
    font-weight: normal;
  }

  .activeTag {
    font-weight: bold;
    background-color: #fff;
    color: #224AE3;
    font-size: 14px;

    &::before {
      content: "";
      width: 2px;
      height: 100%;
      background: #224AE3;
      position: absolute;
      left: 0px;
    }

    &::after {
      content: "";
      height: 100%;
      width: 10px;
      background-repeat: no-repeat;
      background-position: center;
      background-image: url("~@/assets/image/right.png");
      position: absolute;
      right: 5px;
    }
  }
}

.contentContainer {
  flex: 1;
  background-color: #fff;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
  padding: 15px 25px;
  font-size: 14px;
  overflow: auto;
  display: flex;
  flex-direction: column;
}

.title_withLine {
  height: 30px;
  line-height: 30px;
  font-weight: bold;
  box-sizing: border-box;
  position: relative;
  padding-left: 15px;

  &::before {
    content: "";
    display: block;
    width: 5px;
    height: 20px;
    background: #3D7EF7;
    position: absolute;
    left: 0px;
    top: 5px;
  }
}

.exportBtn {
  width: 60px;
  height: 28px;
  font-size: 14px;
  border: 1px solid rgba(34, 74, 227, 1);
  margin-top: 13px;
  text-align: center;
  line-height: 28px;
  background-color: #fff;
  cursor: pointer;
  border-radius: 4px;
  color: #224AE3;
}

.goIndexBtn {
  line-height: 56px;
  font-size: 14px;
  background-image: url("~@/assets/image/shouye.png");
  background-repeat: no-repeat;
  background-size: 16px;
  background-position: 0px center;
  padding-left: 25px;
  cursor: pointer;
}

.red {
  color: #FF5D3F;
}

.green {
  color: #2AC09B;
}
</style>
